import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import AccountConverter from 'scripts/application/dto_converters/account_converter';
import connect from 'components/lib/connect';
import CreateFbAccounts from 'actions/channels/create_fb_accounts';
import FbPagesSelectionModal from './fb_pages_selection_modal';

function FbPagesSelectionModalContainer(props) {
  return <FbPagesSelectionModal onClose={props.onClose} onConfirm={onConfirm} fbPages={props.fbPages} />;

  function onConfirm(selectedFbPageIds) {
    props.onClose();
    props.createFbAccounts(selectedFbPageIds);
  }
}

FbPagesSelectionModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  fbPages: PropTypes.array.isRequired,
  createFbAccounts: PropTypes.func.isRequired,
};

function mapStateToProps(context, props) {
  function getFbPages() {
    let accounts = context.getProvider('accounts').findAll();
    return _.map(accounts, account => _.get(AccountConverter.toDto(account), 'content'));
  }

  return {
    onClose: props.onClose,
    fbPages: getFbPages(),
  };
}

function mapExecuteToProps(executeAction, props) {
  return {
    createFbAccounts(selectedFbPageIds) {
      executeAction(CreateFbAccounts, { selectedFbPageIds });
    },
  };
}

export default connect(mapStateToProps, mapExecuteToProps)(FbPagesSelectionModalContainer);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/modals/fb_pages_selection_modal_container.jsx